module.exports = __webpack_public_path__ + "static/media/1350_Cart_GiftShop_editPopup.61f7921b.png";